import React from "react";
import { Box, Typography, List, ListItem, ListItemText, useTheme } from "@mui/material";

export const GeneralPanel = ({ date }) => {
  const theme = useTheme();

  return (
    <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column", height: "100%" }}>
      <div style={{ marginBottom: "30px" }}>
        <p>
          Fecha de consulta:{" "}
          <span style={{ fontWeight: "600" }}>{date}</span>
        </p>
      </div>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            backgroundColor:
              theme.palette.mode === "dark" ? "#424949" : "#f5f5f5",
            padding: "20px",
            borderRadius: "12px",
            textAlign: "center",
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
            Instrucciones de uso:
          </Typography>
          <List>
            <ListItem>
              <ListItemText primary="• Selecciona un documento desde la parte superior izquierda para comenzar su uso." />
            </ListItem>
            <ListItem>
              <ListItemText primary="• Navega por las distintas opciones." />
            </ListItem>
          </List>
          <Typography variant="body2" color="textSecondary" sx={{ marginTop: 2, fontStyle: "italic" }}>
            Nota: En caso de no elegir un documento, los botones estarán deshabilitados.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
